import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ResultsType } from '../../types';
import { useCallback, useEffect, useState } from 'react';

interface MarkerProps {
  name: string;
  clusterCount?: number;
  isFiltered?: boolean;
}
const ClusterMarker = ({ name, clusterCount, isFiltered }: MarkerProps) => {
  const { t } = useTranslation('common');
  const resultsType = useSelector((state: any) => state.map.resultsType);
  const { isFetching } = useSelector((state: any) => state.map.searchStates);
  const [preservedResultsType, setPreservedResultsType] = useState(resultsType);
  const filters = useSelector((state: any) => state.map.filters);
  const isClusterFiltered = () => {
    if (Object.keys(filters).length === 0) {
      return true;
    } else {
      return isFiltered;
    }
  };
  useEffect(() => {
    if (!isFetching) {
      setPreservedResultsType(resultsType);
    }
  }, [resultsType, isFetching]);
  const renderMarker = useCallback(() => {
    return (
      <Container
        isCompoundLevel={preservedResultsType == ResultsType.COMPOUNDS}
        isFiltered={isClusterFiltered()}
      >
        {preservedResultsType == ResultsType.AREAS && (
          <span className="name">{t(name)}</span>
        )}
        <span className="count">{clusterCount}</span>
      </Container>
    );
  }, [resultsType, isFetching, filters, isFiltered]);

  return renderMarker();
};
const Container = styled.div<{
  isCompoundLevel: boolean;
  isFiltered?: boolean;
}>`
  background-color: ${props => (props.isCompoundLevel ? 'unset' : '#fff')};
  padding: ${props => (props.isCompoundLevel ? 'unset' : '4px 16px')};
  border-radius: 360px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  span {
    font-size: ${props => (props.isCompoundLevel ? '14px' : '12px')};
    font-family: materialMedium;
    &.name {
      color: black;
    }
    &.count {
      display: flex;
      padding: ${props => (props.isCompoundLevel ? '16px' : 'unset')};
      font-size: ${props => (props.isCompoundLevel ? '12px' : 'unset')};
      justify-content: center;
      align-items: center;
      color: #fff;
      background-color: ${props => (props.isFiltered ? '#015c9a' : '#5B6573')};
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
  }
`;
export default ClusterMarker;
